import React from "react";
import { Helmet } from "react-helmet";
import CareerHeader from "../component/Career/CareerHeader";
import CareersContainer from "../component/Career/CareersContainer";

const Career = () => {
  return (
    <div>
      <Helmet>
        <title>Spring Lab, IIT Madras - Career</title>
      </Helmet>
      <CareerHeader />
      <CareersContainer/>  
    </div>
  );
};

export default Career;
